import React from "react";
import { Box, Typography, TextField, Alert } from "@mui/material";
import ConditionBuilder from "../rules/ConditionBuilder";
import {
    CONDITIONS_FORMAT_UNOMI_ONLY,
    usesLoyaltyConditionBuilder,
} from "./segmentConditionsUtils";

const SEGMENT_UI_HINTS = {
    field: {
        datasource: {
            endpoint: "/admin/segments/ui-options/condition-fields",
            brandVia: "X-Brand",
            valueField: "items",
        },
        allowCreate: true,
    },
    operator: {
        options: ["eq", "neq", "gt", "gte", "lt", "lte", "between", "in", "contains", "exists"],
    },
};

const fieldSx = { "& .MuiOutlinedInput-root": { borderRadius: 2 } };

/**
 * Dynamic segment conditions: loyalty AST builder OR read-only / JSON Unomi.
 */
const SegmentConditionsEditor = ({
    segment,
    brandName,
    combinator,
    condRows,
    onConditionsChange,
    unomiJson,
    onUnomiJsonChange,
    unomiJsonReadOnly = false,
}) => {
    const loyaltyBuilder = usesLoyaltyConditionBuilder(segment);

    if (loyaltyBuilder) {
        return (
            <Box>
                <ConditionBuilder
                    brandName={brandName}
                    transactionType="segment_dynamic"
                    conditionCatalog={[]}
                    uiHints={SEGMENT_UI_HINTS}
                    combinator={combinator}
                    rows={condRows}
                    onChange={onConditionsChange}
                    hasPayloadSchema={false}
                    payloadPaths={[]}
                />
            </Box>
        );
    }

    return (
        <Box>
            <Alert severity="warning" sx={{ mb: 1.5, borderRadius: 2 }}>
                Segment importé depuis le CDP : la condition n’est pas éditable via le builder loyalty
                ({CONDITIONS_FORMAT_UNOMI_ONLY}). Vous pouvez consulter ou modifier le JSON Unomi ci-dessous (envoi via{" "}
                <code>unomi_condition</code> au PATCH).
            </Alert>
            <TextField
                fullWidth
                multiline
                minRows={8}
                maxRows={16}
                label="Condition Unomi (JSON)"
                value={unomiJson}
                onChange={(e) => onUnomiJsonChange(e.target.value)}
                disabled={unomiJsonReadOnly}
                placeholder='{ "type": "profilePropertyCondition", ... }'
                sx={fieldSx}
                InputProps={{
                    sx: { fontFamily: "monospace", fontSize: 12 },
                }}
            />
        </Box>
    );
};

export default SegmentConditionsEditor;
export { SEGMENT_UI_HINTS };
